import http from '../../utils/Http/Http'

type BatchExportRespnse = {
	url: string
}

export const getPresignedUrl = async (campaignId: string): Promise<BatchExportRespnse> => {
	const url = `/campaigns/batch_export/${campaignId}`

	const response = await http({
		url,
		method: 'get',
	})

	return response.data
}
